import { render, staticRenderFns } from "./international-roadshows.vue?vue&type=template&id=6b0a2aab"
import script from "./international-roadshows.vue?vue&type=script&lang=js"
export * from "./international-roadshows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/roadshows-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fraise-capital%2Flisting-services%2Finternational-roadshows.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/roadshows-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fraise-capital%2Flisting-services%2Finternational-roadshows.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,HalfImageHalfGrid: require('/vercel/path0/components/HalfImageHalfGrid.vue').default})
